import { CssBaseline, ThemeProvider } from '@mui/material';
import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { primaryTheme } from './assets/utils/theme';
import AppRoutes from './routes/App.routes';
import { authSelector } from './features/selectors';
import { useSelector } from 'react-redux';
import useAuth from './hooks/useAuth';
import { isEmpty } from 'lodash';
import { isMobile } from 'react-device-detect';
import MobDetect from './pages/errors/MobDetect';

// !#################### MAIN FUNC ##################
const App = () => {
    // ######### Redux states #############
    const { user } = useSelector(authSelector);

    // ######### Get user profile #########
    const auth = useAuth();
    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed) {
            if (isEmpty(user)) {
                auth.persistAuthenticatedUser();
            }
        }
        return () => {
            isSubscribed = false;
        };
    }, [user, auth]);
    return (
        <React.Fragment>
            <ThemeProvider theme={primaryTheme}>
                <CssBaseline />
                {isMobile ? <MobDetect /> : <AppRoutes />}
                <Toaster />
            </ThemeProvider>
        </React.Fragment>
    );
};

export default App;
